import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

type Props = {
  src: string;
  style?: React.CSSProperties;
  disableNativeFullscreen?: boolean;
};

const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
`;

export default function AutoPlayVideo({ src, style = {}, disableNativeFullscreen }: Props) {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handleFullscreenChange = () => {
    const video = videoRef.current;
    if (!video) return;
    const isFullscreen = document.fullscreenElement === video;

    if (isFullscreen) {
      video.muted = false;
      video.currentTime = 0;
      video.pause();
    } else {
      video.muted = true;
    }
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  const openFullScreenOnClick = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.requestFullscreen) {
      video.requestFullscreen();
    }
  };

  return (
    <StyledVideo
      ref={videoRef}
      src={src}
      autoPlay
      playsInline
      onClick={disableNativeFullscreen ? undefined : openFullScreenOnClick}
      onTouchStart={disableNativeFullscreen ? undefined : openFullScreenOnClick}
      muted
      controls
      disablePictureInPicture
      disableRemotePlayback
      controlsList={disableNativeFullscreen ? 'nodownload nofullscreen' : 'nodownload'}
      style={style}
    />
  );
}
